import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { isAuthenticated, logout } from "../Utilities/Auth";
import AdminLayout from "../Layout/AdminLayout";
import { ClientProvider } from "../Utilities/ClientContext";

const PrivateRoutes = () => {
	if(isAuthenticated()){
        return <ClientProvider><AdminLayout><Outlet/></AdminLayout></ClientProvider>
    }
    else{
        logout();
        return <Navigate to="/login" />
    }
};

export default PrivateRoutes;